import { useMemo } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { JiraProjectPicker } from '../../../components/jira/JiraProjectPicker';
import { jiraListings } from '../../../components/jira/listings';
import {
  PROJECT_LISTING_UNAVAILABLE,
  isListedJiraInstance,
} from '../../../components/jira/presets';
import { jiraInstanceOf } from '../jiraForm';

const FIELD_ID = 'jira-project-key';
const TITLE = 'Jira project key';

export const JiraProjectField = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { onChange, formData, formContext, rawErrors, schema } = props;
  const discovery = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const listings = useMemo(
    () => jiraListings(discovery, fetchApi),
    [discovery, fetchApi],
  );

  const instance = jiraInstanceOf(formContext);
  const error = (rawErrors ?? [])[0];

  return (
    <JiraProjectPicker
      id={FIELD_ID}
      title={schema.title ?? TITLE}
      value={formData ?? ''}
      onChange={onChange}
      listings={listings}
      error={error}
      unavailableReason={
        isListedJiraInstance(instance) ? undefined : PROJECT_LISTING_UNAVAILABLE
      }
    />
  );
};
